/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BaseHit Api
 * An API for accessing data for BaseHit.com
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DepthChartUpdate,
  DraftListUpdateRequest,
  ErrorResult,
  GetTeamLeagueIdAdvancedDefenseParams,
  GetTeamLeagueIdBattingOrderParams,
  GetTeamLeagueIdDefenseParams,
  GetTeamLeagueIdLeadersParams,
  GetTeamLeagueIdNewsParams,
  GetTeamLeagueIdScheduleParams,
  GetTeamLeagueIdStatsParams,
  GetTeamLeagueIdTransactionsParams,
  GetTeamLeagueIdUpcomingGamesParams,
  Int32RosterLevelKeyValuePair,
  ManagerSettings,
  PendingPositionChangeRequest,
  PendingPositionChangesRoster,
  PlaceFreeAgentBidDto,
  ProblemDetails,
  PutTeamLeagueIdLineupsParams,
  Stadium,
  TeamAchievementsResponse,
  TeamAdvancedDefenseResponse,
  TeamAwardsResponse,
  TeamBattingOrderViewResponse,
  TeamColorUpdateRequest,
  TeamContracts,
  TeamDefenseViewResponse,
  TeamDepthChartViewResponse,
  TeamDraftHistoryResponse,
  TeamDraftListView,
  TeamIdentityResponse,
  TeamLeadersResponse,
  TeamLineupUpdate,
  TeamLineupsViewResponse,
  TeamManagerSettingsView,
  TeamNameUpdateRequest,
  TeamNewsResponse,
  TeamPitchingRoleUpdate,
  TeamPitchingRolesViewResponse,
  TeamPreviewResponse,
  TeamRosterViewResponse,
  TeamScheduleResponse,
  TeamSeasonsResponse,
  TeamStadiumViewResponse,
  TeamStatsResponse,
  TeamTransactionsResponse,
  TeamUpcomingGamesResponse,
  TeamViewResponse
} from '../models';

import { fetcher } from '../../fetcher';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Amateur-draft prep for the team (owner-only): the team's draft picks plus
the editable draft list (pitchers / position players). 404 when the
team/league cannot be resolved or the league has no draft.
 */
export const getTeamLeagueIdDraftList = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamDraftListView>(
      {url: `/Team/League/${id}/DraftList`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdDraftListQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/DraftList`
    ] as const;
    }


export const getGetTeamLeagueIdDraftListQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdDraftListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>> = ({ signal }) => getTeamLeagueIdDraftList(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdDraftListQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>>
export type GetTeamLeagueIdDraftListQueryError = ProblemDetails


export function useGetTeamLeagueIdDraftList<TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdDraftList<TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdDraftList<TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Amateur-draft prep for the team (owner-only): the team's draft picks plus
the editable draft list (pitchers / position players). 404 when the
team/league cannot be resolved or the league has no draft.
 */

export function useGetTeamLeagueIdDraftList<TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdDraftListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Re-ranks the team's current-season draft list (full 1..N order, owner-only).
 */
export const putTeamLeagueIdDraftList = (
    id: number,
    draftListUpdateRequest?: DraftListUpdateRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/DraftList`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: draftListUpdateRequest, signal
    },
      );
    }




export const getPutTeamLeagueIdDraftListMutationKey = () => ['putTeamLeagueIdDraftList'] as const;

export const getPutTeamLeagueIdDraftListMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdDraftList>>, TError,PutTeamLeagueIdDraftListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdDraftList>>, TError,PutTeamLeagueIdDraftListMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdDraftListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdDraftList>>, PutTeamLeagueIdDraftListMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdDraftList(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdDraftListMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdDraftList>>>
    export type PutTeamLeagueIdDraftListMutationBody = DraftListUpdateRequest | undefined
    export type PutTeamLeagueIdDraftListMutationError = ErrorResult | ProblemDetails
    export type PutTeamLeagueIdDraftListMutationVariables = {id: number;data?: DraftListUpdateRequest}

    /**
 * @summary Re-ranks the team's current-season draft list (full 1..N order, owner-only).
 */
export const usePutTeamLeagueIdDraftList = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdDraftList>>, TError,PutTeamLeagueIdDraftListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdDraftList>>,
        TError,
        PutTeamLeagueIdDraftListMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdDraftListMutationOptions(options), queryClient);
    }
    /**
 * @summary Resets the team's current-season draft list to the default order (owner-only).
 */
export const postTeamLeagueIdDraftListReset = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/DraftList/Reset`, method: 'POST', signal
    },
      );
    }




export const getPostTeamLeagueIdDraftListResetMutationKey = () => ['postTeamLeagueIdDraftListReset'] as const;

export const getPostTeamLeagueIdDraftListResetMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTeamLeagueIdDraftListReset>>, TError,PostTeamLeagueIdDraftListResetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTeamLeagueIdDraftListReset>>, TError,PostTeamLeagueIdDraftListResetMutationVariables, TContext> => {

const mutationKey = getPostTeamLeagueIdDraftListResetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTeamLeagueIdDraftListReset>>, PostTeamLeagueIdDraftListResetMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  postTeamLeagueIdDraftListReset(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostTeamLeagueIdDraftListResetMutationResult = NonNullable<Awaited<ReturnType<typeof postTeamLeagueIdDraftListReset>>>

    export type PostTeamLeagueIdDraftListResetMutationError = ProblemDetails
    export type PostTeamLeagueIdDraftListResetMutationVariables = {id: number}

    /**
 * @summary Resets the team's current-season draft list to the default order (owner-only).
 */
export const usePostTeamLeagueIdDraftListReset = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTeamLeagueIdDraftListReset>>, TError,PostTeamLeagueIdDraftListResetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTeamLeagueIdDraftListReset>>,
        TError,
        PostTeamLeagueIdDraftListResetMutationVariables,
        TContext
      > => {
      return useMutation(getPostTeamLeagueIdDraftListResetMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns the team's season-by-season history (per the unchanged
dbo.TeamGetSeasons proc). Empty rows is a valid 200; 404 when the
team doesn't exist.
 */
export const getTeamLeagueIdSeasons = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamSeasonsResponse>(
      {url: `/Team/League/${id}/Seasons`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdSeasonsQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/Seasons`
    ] as const;
    }


export const getGetTeamLeagueIdSeasonsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdSeasonsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>> = ({ signal }) => getTeamLeagueIdSeasons(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdSeasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>>
export type GetTeamLeagueIdSeasonsQueryError = ProblemDetails


export function useGetTeamLeagueIdSeasons<TData = Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdSeasons<TData = Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdSeasons<TData = Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team's season-by-season history (per the unchanged
dbo.TeamGetSeasons proc). Empty rows is a valid 200; 404 when the
team doesn't exist.
 */

export function useGetTeamLeagueIdSeasons<TData = Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSeasons>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdSeasonsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the team's player achievements (no-hitters, cycles, perfect
games, etc. — per the unchanged dbo.TeamGetAchievements proc).
Empty rows is a valid 200; 404 when the team doesn't exist.
 */
export const getTeamLeagueIdAchievements = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamAchievementsResponse>(
      {url: `/Team/League/${id}/Achievements`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdAchievementsQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/Achievements`
    ] as const;
    }


export const getGetTeamLeagueIdAchievementsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdAchievementsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>> = ({ signal }) => getTeamLeagueIdAchievements(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdAchievementsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>>
export type GetTeamLeagueIdAchievementsQueryError = ProblemDetails


export function useGetTeamLeagueIdAchievements<TData = Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdAchievements<TData = Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdAchievements<TData = Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team's player achievements (no-hitters, cycles, perfect
games, etc. — per the unchanged dbo.TeamGetAchievements proc).
Empty rows is a valid 200; 404 when the team doesn't exist.
 */

export function useGetTeamLeagueIdAchievements<TData = Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAchievements>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdAchievementsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the team's season-by-season awards and career award totals.
404 when the team doesn't exist OR the league doesn't have awards
enabled (parity with team/awards.asp line 13 Return404WithTemplate).
 */
export const getTeamLeagueIdAwards = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamAwardsResponse>(
      {url: `/Team/League/${id}/Awards`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdAwardsQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/Awards`
    ] as const;
    }


export const getGetTeamLeagueIdAwardsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdAwardsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdAwards>>> = ({ signal }) => getTeamLeagueIdAwards(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdAwardsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdAwards>>>
export type GetTeamLeagueIdAwardsQueryError = ProblemDetails


export function useGetTeamLeagueIdAwards<TData = Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdAwards>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdAwards>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdAwards<TData = Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdAwards>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdAwards>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdAwards<TData = Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team's season-by-season awards and career award totals.
404 when the team doesn't exist OR the league doesn't have awards
enabled (parity with team/awards.asp line 13 Return404WithTemplate).
 */

export function useGetTeamLeagueIdAwards<TData = Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAwards>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdAwardsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the team's draft picks (per the unchanged dbo.TeamGetDraftHistory
proc). Each row carries the player + 12 potential ratings + 4 overall
potentials + career stats + award counts. 404 when the team doesn't
exist OR the league doesn't have draft enabled (parity with
drafthistory.asp line 13 Return404WithTemplate).
 */
export const getTeamLeagueIdDraftHistory = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamDraftHistoryResponse>(
      {url: `/Team/League/${id}/DraftHistory`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdDraftHistoryQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/DraftHistory`
    ] as const;
    }


export const getGetTeamLeagueIdDraftHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdDraftHistoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>> = ({ signal }) => getTeamLeagueIdDraftHistory(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdDraftHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>>
export type GetTeamLeagueIdDraftHistoryQueryError = ProblemDetails


export function useGetTeamLeagueIdDraftHistory<TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdDraftHistory<TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdDraftHistory<TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team's draft picks (per the unchanged dbo.TeamGetDraftHistory
proc). Each row carries the player + 12 potential ratings + 4 overall
potentials + career stats + award counts. 404 when the team doesn't
exist OR the league doesn't have draft enabled (parity with
drafthistory.asp line 13 Return404WithTemplate).
 */

export function useGetTeamLeagueIdDraftHistory<TData = Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDraftHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdDraftHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the team's all-time / single-season leaders for one of four
views via ?show={seasonbatting|seasonpitching|careerbatting|careerpitching}.
Empty/null show defaults to seasonbatting. Non-empty unknown keys return
400. Service returns null only when the team doesn't exist → controller 404.
 */
export const getTeamLeagueIdLeaders = (
    id: number,
    params?: GetTeamLeagueIdLeadersParams,
 signal?: AbortSignal
) => {


      return fetcher<TeamLeadersResponse>(
      {url: `/Team/League/${id}/Leaders`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTeamLeagueIdLeadersQueryKey = (id: number,
    params?: GetTeamLeagueIdLeadersParams,) => {
    return [
    `/Team/League/${id}/Leaders`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamLeagueIdLeadersQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError = ErrorResult | ProblemDetails>(id: number,
    params?: GetTeamLeagueIdLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdLeadersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>> = ({ signal }) => getTeamLeagueIdLeaders(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdLeadersQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>>
export type GetTeamLeagueIdLeadersQueryError = ErrorResult | ProblemDetails


export function useGetTeamLeagueIdLeaders<TData = Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError = ErrorResult | ProblemDetails>(
 id: number,
    params: undefined |  GetTeamLeagueIdLeadersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdLeaders<TData = Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError = ErrorResult | ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdLeaders<TData = Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError = ErrorResult | ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team's all-time / single-season leaders for one of four
views via ?show={seasonbatting|seasonpitching|careerbatting|careerpitching}.
Empty/null show defaults to seasonbatting. Non-empty unknown keys return
400. Service returns null only when the team doesn't exist → controller 404.
 */

export function useGetTeamLeagueIdLeaders<TData = Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError = ErrorResult | ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLeaders>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdLeadersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the team's transactions (drafts, signings, releases, trades,
reassignments, etc.) for one season. Requires auth. 404 when the team or
league is missing, the league lacks transactions enabled, or the
requested season is out of range. Empty rows is a valid 200 — React
renders a neutral empty-state.
 */
export const getTeamLeagueIdTransactions = (
    id: number,
    params?: GetTeamLeagueIdTransactionsParams,
 signal?: AbortSignal
) => {


      return fetcher<TeamTransactionsResponse>(
      {url: `/Team/League/${id}/Transactions`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTeamLeagueIdTransactionsQueryKey = (id: number,
    params?: GetTeamLeagueIdTransactionsParams,) => {
    return [
    `/Team/League/${id}/Transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamLeagueIdTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError = ProblemDetails>(id: number,
    params?: GetTeamLeagueIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdTransactionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>> = ({ signal }) => getTeamLeagueIdTransactions(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>>
export type GetTeamLeagueIdTransactionsQueryError = ProblemDetails


export function useGetTeamLeagueIdTransactions<TData = Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetTeamLeagueIdTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdTransactions<TData = Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdTransactions<TData = Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team's transactions (drafts, signings, releases, trades,
reassignments, etc.) for one season. Requires auth. 404 when the team or
league is missing, the league lacks transactions enabled, or the
requested season is out of range. Empty rows is a valid 200 — React
renders a neutral empty-state.
 */

export function useGetTeamLeagueIdTransactions<TData = Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdTransactionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the team's batting/pitching/fielding stats for one of 6 view types
(Current Season / Career / Current Playoffs / Career Playoffs / Last 3 Seasons
/ All Seasons = 6) or a specific season year (show > 6). Requires auth. 404 when
team or league missing, type out of range (1-5), or show out of range
(1-6 or [team.FirstYear..team.LastYear]).
 */
export const getTeamLeagueIdStats = (
    id: number,
    params?: GetTeamLeagueIdStatsParams,
 signal?: AbortSignal
) => {


      return fetcher<TeamStatsResponse>(
      {url: `/Team/League/${id}/Stats`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTeamLeagueIdStatsQueryKey = (id: number,
    params?: GetTeamLeagueIdStatsParams,) => {
    return [
    `/Team/League/${id}/Stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamLeagueIdStatsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError = ProblemDetails>(id: number,
    params?: GetTeamLeagueIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdStatsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdStats>>> = ({ signal }) => getTeamLeagueIdStats(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdStats>>>
export type GetTeamLeagueIdStatsQueryError = ProblemDetails


export function useGetTeamLeagueIdStats<TData = Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetTeamLeagueIdStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdStats>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdStats<TData = Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdStats>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdStats<TData = Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team's batting/pitching/fielding stats for one of 6 view types
(Current Season / Career / Current Playoffs / Career Playoffs / Last 3 Seasons
/ All Seasons = 6) or a specific season year (show > 6). Requires auth. 404 when
team or league missing, type out of range (1-5), or show out of range
(1-6 or [team.FirstYear..team.LastYear]).
 */

export function useGetTeamLeagueIdStats<TData = Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdStatsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Team defensive RAA: a season's roster by area (with per-position detail) and the
franchise history with league rank. `season` is the season YEAR (as on every other season-browsing endpoint); omitted = latest
season with data. Requires auth. 404 when the team/league is missing, the league lacks
the advanced-defense-stats flag, or the requested season has no data.
 */
export const getTeamLeagueIdAdvancedDefense = (
    id: number,
    params?: GetTeamLeagueIdAdvancedDefenseParams,
 signal?: AbortSignal
) => {


      return fetcher<TeamAdvancedDefenseResponse>(
      {url: `/Team/League/${id}/AdvancedDefense`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTeamLeagueIdAdvancedDefenseQueryKey = (id: number,
    params?: GetTeamLeagueIdAdvancedDefenseParams,) => {
    return [
    `/Team/League/${id}/AdvancedDefense`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamLeagueIdAdvancedDefenseQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError = ProblemDetails>(id: number,
    params?: GetTeamLeagueIdAdvancedDefenseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdAdvancedDefenseQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>> = ({ signal }) => getTeamLeagueIdAdvancedDefense(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdAdvancedDefenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>>
export type GetTeamLeagueIdAdvancedDefenseQueryError = ProblemDetails


export function useGetTeamLeagueIdAdvancedDefense<TData = Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetTeamLeagueIdAdvancedDefenseParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdAdvancedDefense<TData = Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdAdvancedDefenseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdAdvancedDefense<TData = Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdAdvancedDefenseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Team defensive RAA: a season's roster by area (with per-position detail) and the
franchise history with league rank. `season` is the season YEAR (as on every other season-browsing endpoint); omitted = latest
season with data. Requires auth. 404 when the team/league is missing, the league lacks
the advanced-defense-stats flag, or the requested season has no data.
 */

export function useGetTeamLeagueIdAdvancedDefense<TData = Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdAdvancedDefenseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdAdvancedDefense>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdAdvancedDefenseQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the team's season schedule with regular-season and (if applicable)
playoff games. Requires auth. 404 when team or league missing, the team has
no schedule (exhibition without an owner), the team has no seasons rows,
or season is out of range (must fall in [team.FirstYear..team.LastYear]).
 */
export const getTeamLeagueIdSchedule = (
    id: number,
    params?: GetTeamLeagueIdScheduleParams,
 signal?: AbortSignal
) => {


      return fetcher<TeamScheduleResponse>(
      {url: `/Team/League/${id}/Schedule`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTeamLeagueIdScheduleQueryKey = (id: number,
    params?: GetTeamLeagueIdScheduleParams,) => {
    return [
    `/Team/League/${id}/Schedule`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamLeagueIdScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError = ProblemDetails>(id: number,
    params?: GetTeamLeagueIdScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdScheduleQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>> = ({ signal }) => getTeamLeagueIdSchedule(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>>
export type GetTeamLeagueIdScheduleQueryError = ProblemDetails


export function useGetTeamLeagueIdSchedule<TData = Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetTeamLeagueIdScheduleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdSchedule<TData = Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdSchedule<TData = Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team's season schedule with regular-season and (if applicable)
playoff games. Requires auth. 404 when team or league missing, the team has
no schedule (exhibition without an owner), the team has no seasons rows,
or season is out of range (must fall in [team.FirstYear..team.LastYear]).
 */

export function useGetTeamLeagueIdSchedule<TData = Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdSchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdScheduleQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns a paginated page of news items for the team with pre-resolved
tokens for rendering. Requires auth. 404 when team or league missing, or
when page is less than 1. Out-of-range page (too high) returns 200 with
empty items + HasMore=false.
 */
export const getTeamLeagueIdNews = (
    id: number,
    params?: GetTeamLeagueIdNewsParams,
 signal?: AbortSignal
) => {


      return fetcher<TeamNewsResponse>(
      {url: `/Team/League/${id}/News`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTeamLeagueIdNewsQueryKey = (id: number,
    params?: GetTeamLeagueIdNewsParams,) => {
    return [
    `/Team/League/${id}/News`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamLeagueIdNewsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError = ProblemDetails>(id: number,
    params?: GetTeamLeagueIdNewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdNewsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdNews>>> = ({ signal }) => getTeamLeagueIdNews(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdNewsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdNews>>>
export type GetTeamLeagueIdNewsQueryError = ProblemDetails


export function useGetTeamLeagueIdNews<TData = Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetTeamLeagueIdNewsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdNews>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdNews>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdNews<TData = Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdNewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdNews>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdNews>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdNews<TData = Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdNewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a paginated page of news items for the team with pre-resolved
tokens for rendering. Requires auth. 404 when team or league missing, or
when page is less than 1. Out-of-range page (too high) returns 200 with
empty items + HasMore=false.
 */

export function useGetTeamLeagueIdNews<TData = Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdNewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdNews>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdNewsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns recent seasons + top pitchers + top hitters for a team.
Used by the /teams find-team shopper preview drawer. Requires auth.
404 when team or league missing.
 */
export const getTeamLeagueIdPreview = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamPreviewResponse>(
      {url: `/Team/League/${id}/Preview`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdPreviewQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/Preview`
    ] as const;
    }


export const getGetTeamLeagueIdPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdPreviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdPreview>>> = ({ signal }) => getTeamLeagueIdPreview(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdPreview>>>
export type GetTeamLeagueIdPreviewQueryError = ProblemDetails


export function useGetTeamLeagueIdPreview<TData = Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdPreview>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdPreview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdPreview<TData = Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdPreview>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdPreview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdPreview<TData = Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns recent seasons + top pitchers + top hitters for a team.
Used by the /teams find-team shopper preview drawer. Requires auth.
404 when team or league missing.
 */

export function useGetTeamLeagueIdPreview<TData = Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPreview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdPreviewQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Flat team-identity read for the shared team nav + team pages (identity +
league ref + CanManage).
 */
export const getTeamLeagueId = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamIdentityResponse>(
      {url: `/Team/League/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}`
    ] as const;
    }


export const getGetTeamLeagueIdQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueId>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueId>>> = ({ signal }) => getTeamLeagueId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueId>>>
export type GetTeamLeagueIdQueryError = ProblemDetails


export function useGetTeamLeagueId<TData = Awaited<ReturnType<typeof getTeamLeagueId>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueId>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueId<TData = Awaited<ReturnType<typeof getTeamLeagueId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueId>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueId<TData = Awaited<ReturnType<typeof getTeamLeagueId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Flat team-identity read for the shared team nav + team pages (identity +
league ref + CanManage).
 */

export function useGetTeamLeagueId<TData = Awaited<ReturnType<typeof getTeamLeagueId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary View-shaped roster payload for the team/roster page (+ the trades
AddToBlock and freeagents financials consumers). Requires auth; user-aware:
CanManage = HasLeagueTeamOwnerAccess.
 */
export const getTeamLeagueIdRoster = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamRosterViewResponse>(
      {url: `/Team/League/${id}/Roster`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdRosterQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/Roster`
    ] as const;
    }


export const getGetTeamLeagueIdRosterQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdRosterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdRoster>>> = ({ signal }) => getTeamLeagueIdRoster(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdRosterQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdRoster>>>
export type GetTeamLeagueIdRosterQueryError = ProblemDetails


export function useGetTeamLeagueIdRoster<TData = Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdRoster>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdRoster>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdRoster<TData = Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdRoster>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdRoster>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdRoster<TData = Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary View-shaped roster payload for the team/roster page (+ the trades
AddToBlock and freeagents financials consumers). Requires auth; user-aware:
CanManage = HasLeagueTeamOwnerAccess.
 */

export function useGetTeamLeagueIdRoster<TData = Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdRoster>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdRosterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTeamLeagueIdContracts = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamContracts>(
      {url: `/Team/League/${id}/Contracts`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdContractsQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/Contracts`
    ] as const;
    }


export const getGetTeamLeagueIdContractsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdContractsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdContracts>>> = ({ signal }) => getTeamLeagueIdContracts(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdContracts>>>
export type GetTeamLeagueIdContractsQueryError = ProblemDetails


export function useGetTeamLeagueIdContracts<TData = Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdContracts>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdContracts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdContracts<TData = Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdContracts>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdContracts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdContracts<TData = Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTeamLeagueIdContracts<TData = Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdContracts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdContractsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putTeamLeagueIdContracts = (
    id: number,
    putTeamLeagueIdContractsBody?: number[],
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/Contracts`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putTeamLeagueIdContractsBody, signal
    },
      );
    }




export const getPutTeamLeagueIdContractsMutationKey = () => ['putTeamLeagueIdContracts'] as const;

export const getPutTeamLeagueIdContractsMutationOptions = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdContracts>>, TError,PutTeamLeagueIdContractsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdContracts>>, TError,PutTeamLeagueIdContractsMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdContractsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdContracts>>, PutTeamLeagueIdContractsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdContracts(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdContractsMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdContracts>>>
    export type PutTeamLeagueIdContractsMutationBody = number[] | undefined
    export type PutTeamLeagueIdContractsMutationError = ErrorResult
    export type PutTeamLeagueIdContractsMutationVariables = {id: number;data?: number[]}

    export const usePutTeamLeagueIdContracts = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdContracts>>, TError,PutTeamLeagueIdContractsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdContracts>>,
        TError,
        PutTeamLeagueIdContractsMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdContractsMutationOptions(options), queryClient);
    }
    export const putTeamLeagueIdStadium = (
    id: number,
    stadium?: Stadium,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/Stadium`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: stadium, signal
    },
      );
    }




export const getPutTeamLeagueIdStadiumMutationKey = () => ['putTeamLeagueIdStadium'] as const;

export const getPutTeamLeagueIdStadiumMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdStadium>>, TError,PutTeamLeagueIdStadiumMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdStadium>>, TError,PutTeamLeagueIdStadiumMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdStadiumMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdStadium>>, PutTeamLeagueIdStadiumMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdStadium(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdStadiumMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdStadium>>>
    export type PutTeamLeagueIdStadiumMutationBody = Stadium | undefined
    export type PutTeamLeagueIdStadiumMutationError = ErrorResult | ProblemDetails
    export type PutTeamLeagueIdStadiumMutationVariables = {id: number;data?: Stadium}

    export const usePutTeamLeagueIdStadium = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdStadium>>, TError,PutTeamLeagueIdStadiumMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdStadium>>,
        TError,
        PutTeamLeagueIdStadiumMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdStadiumMutationOptions(options), queryClient);
    }
    /**
 * @summary Current stadium dimensions plus the owner-editable flag for the edit-stadium modal. Owner-only.
 */
export const getTeamLeagueIdStadium = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamStadiumViewResponse>(
      {url: `/Team/League/${id}/Stadium`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdStadiumQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/Stadium`
    ] as const;
    }


export const getGetTeamLeagueIdStadiumQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdStadiumQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdStadium>>> = ({ signal }) => getTeamLeagueIdStadium(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdStadiumQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdStadium>>>
export type GetTeamLeagueIdStadiumQueryError = ProblemDetails


export function useGetTeamLeagueIdStadium<TData = Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdStadium>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdStadium>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdStadium<TData = Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdStadium>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdStadium>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdStadium<TData = Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Current stadium dimensions plus the owner-editable flag for the edit-stadium modal. Owner-only.
 */

export function useGetTeamLeagueIdStadium<TData = Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdStadium>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdStadiumQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putTeamLeagueIdLineups = (
    id: number,
    teamLineupUpdate?: TeamLineupUpdate[],
    params?: PutTeamLeagueIdLineupsParams,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/Lineups`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: teamLineupUpdate,
        params, signal
    },
      );
    }




export const getPutTeamLeagueIdLineupsMutationKey = () => ['putTeamLeagueIdLineups'] as const;

export const getPutTeamLeagueIdLineupsMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdLineups>>, TError,PutTeamLeagueIdLineupsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdLineups>>, TError,PutTeamLeagueIdLineupsMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdLineupsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdLineups>>, PutTeamLeagueIdLineupsMutationVariables> = (props) => {
          const {id,data,params} = props ?? {};

          return  putTeamLeagueIdLineups(id,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdLineupsMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdLineups>>>
    export type PutTeamLeagueIdLineupsMutationBody = TeamLineupUpdate[] | undefined
    export type PutTeamLeagueIdLineupsMutationError = ErrorResult | ProblemDetails
    export type PutTeamLeagueIdLineupsMutationVariables = {id: number;data?: TeamLineupUpdate[];params?: PutTeamLeagueIdLineupsParams}

    export const usePutTeamLeagueIdLineups = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdLineups>>, TError,PutTeamLeagueIdLineupsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdLineups>>,
        TError,
        PutTeamLeagueIdLineupsMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdLineupsMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns the team-lineups hub payload. Requires auth; user-aware
(canManage flag resolved server-side from owner-access check).
3 sections (pitchers + batters vs RHP + batters vs LHP) with
stats embedded per legacy parity.
 */
export const getTeamLeagueIdLineups = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamLineupsViewResponse>(
      {url: `/Team/League/${id}/Lineups`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdLineupsQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/Lineups`
    ] as const;
    }


export const getGetTeamLeagueIdLineupsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdLineupsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdLineups>>> = ({ signal }) => getTeamLeagueIdLineups(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdLineupsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdLineups>>>
export type GetTeamLeagueIdLineupsQueryError = ProblemDetails


export function useGetTeamLeagueIdLineups<TData = Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdLineups>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdLineups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdLineups<TData = Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdLineups>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdLineups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdLineups<TData = Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team-lineups hub payload. Requires auth; user-aware
(canManage flag resolved server-side from owner-access check).
3 sections (pitchers + batters vs RHP + batters vs LHP) with
stats embedded per legacy parity.
 */

export function useGetTeamLeagueIdLineups<TData = Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdLineups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdLineupsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putTeamLeagueIdPitchingRoles = (
    id: number,
    teamPitchingRoleUpdate?: TeamPitchingRoleUpdate[],
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/PitchingRoles`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: teamPitchingRoleUpdate, signal
    },
      );
    }




export const getPutTeamLeagueIdPitchingRolesMutationKey = () => ['putTeamLeagueIdPitchingRoles'] as const;

export const getPutTeamLeagueIdPitchingRolesMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdPitchingRoles>>, TError,PutTeamLeagueIdPitchingRolesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdPitchingRoles>>, TError,PutTeamLeagueIdPitchingRolesMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdPitchingRolesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdPitchingRoles>>, PutTeamLeagueIdPitchingRolesMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdPitchingRoles(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdPitchingRolesMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdPitchingRoles>>>
    export type PutTeamLeagueIdPitchingRolesMutationBody = TeamPitchingRoleUpdate[] | undefined
    export type PutTeamLeagueIdPitchingRolesMutationError = ErrorResult | ProblemDetails
    export type PutTeamLeagueIdPitchingRolesMutationVariables = {id: number;data?: TeamPitchingRoleUpdate[]}

    export const usePutTeamLeagueIdPitchingRoles = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdPitchingRoles>>, TError,PutTeamLeagueIdPitchingRolesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdPitchingRoles>>,
        TError,
        PutTeamLeagueIdPitchingRolesMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdPitchingRolesMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns the pitching-roles-editor payload for the team. Requires auth; user-aware
API surface; service returns null (404) for non-owners AND for owners whose
rosters are locked. Edit-only -- read-only viewing lives on the hub.
 */
export const getTeamLeagueIdPitchingRoles = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamPitchingRolesViewResponse>(
      {url: `/Team/League/${id}/PitchingRoles`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdPitchingRolesQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/PitchingRoles`
    ] as const;
    }


export const getGetTeamLeagueIdPitchingRolesQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdPitchingRolesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>> = ({ signal }) => getTeamLeagueIdPitchingRoles(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdPitchingRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>>
export type GetTeamLeagueIdPitchingRolesQueryError = ProblemDetails


export function useGetTeamLeagueIdPitchingRoles<TData = Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdPitchingRoles<TData = Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdPitchingRoles<TData = Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the pitching-roles-editor payload for the team. Requires auth; user-aware
API surface; service returns null (404) for non-owners AND for owners whose
rosters are locked. Edit-only -- read-only viewing lives on the hub.
 */

export function useGetTeamLeagueIdPitchingRoles<TData = Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPitchingRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdPitchingRolesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putTeamLeagueIdDepthChart = (
    id: number,
    depthChartUpdate?: DepthChartUpdate[],
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/DepthChart`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: depthChartUpdate, signal
    },
      );
    }




export const getPutTeamLeagueIdDepthChartMutationKey = () => ['putTeamLeagueIdDepthChart'] as const;

export const getPutTeamLeagueIdDepthChartMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdDepthChart>>, TError,PutTeamLeagueIdDepthChartMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdDepthChart>>, TError,PutTeamLeagueIdDepthChartMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdDepthChartMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdDepthChart>>, PutTeamLeagueIdDepthChartMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdDepthChart(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdDepthChartMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdDepthChart>>>
    export type PutTeamLeagueIdDepthChartMutationBody = DepthChartUpdate[] | undefined
    export type PutTeamLeagueIdDepthChartMutationError = ErrorResult | ProblemDetails
    export type PutTeamLeagueIdDepthChartMutationVariables = {id: number;data?: DepthChartUpdate[]}

    export const usePutTeamLeagueIdDepthChart = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdDepthChart>>, TError,PutTeamLeagueIdDepthChartMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdDepthChart>>,
        TError,
        PutTeamLeagueIdDepthChartMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdDepthChartMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns the team-depthchart page payload. Requires auth; canManage
drives whether the matrix renders editable. Positions list is
the full 9x3 matrix (gap-filled with null playerIds).
 */
export const getTeamLeagueIdDepthChart = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamDepthChartViewResponse>(
      {url: `/Team/League/${id}/DepthChart`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdDepthChartQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/DepthChart`
    ] as const;
    }


export const getGetTeamLeagueIdDepthChartQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdDepthChartQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>> = ({ signal }) => getTeamLeagueIdDepthChart(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdDepthChartQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>>
export type GetTeamLeagueIdDepthChartQueryError = ProblemDetails


export function useGetTeamLeagueIdDepthChart<TData = Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdDepthChart<TData = Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdDepthChart<TData = Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team-depthchart page payload. Requires auth; canManage
drives whether the matrix renders editable. Positions list is
the full 9x3 matrix (gap-filled with null playerIds).
 */

export function useGetTeamLeagueIdDepthChart<TData = Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDepthChart>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdDepthChartQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Manager AI settings for the team/manager page (owner-only), with the
rosters-locked and in-postseason gate flags. View-shaped read.
 */
export const getTeamLeagueIdManagerSettings = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamManagerSettingsView>(
      {url: `/Team/League/${id}/ManagerSettings`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdManagerSettingsQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/ManagerSettings`
    ] as const;
    }


export const getGetTeamLeagueIdManagerSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdManagerSettingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>> = ({ signal }) => getTeamLeagueIdManagerSettings(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdManagerSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>>
export type GetTeamLeagueIdManagerSettingsQueryError = ProblemDetails


export function useGetTeamLeagueIdManagerSettings<TData = Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdManagerSettings<TData = Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdManagerSettings<TData = Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Manager AI settings for the team/manager page (owner-only), with the
rosters-locked and in-postseason gate flags. View-shaped read.
 */

export function useGetTeamLeagueIdManagerSettings<TData = Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdManagerSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdManagerSettingsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putTeamLeagueIdManagerSettings = (
    id: number,
    managerSettings?: ManagerSettings,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/ManagerSettings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: managerSettings, signal
    },
      );
    }




export const getPutTeamLeagueIdManagerSettingsMutationKey = () => ['putTeamLeagueIdManagerSettings'] as const;

export const getPutTeamLeagueIdManagerSettingsMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdManagerSettings>>, TError,PutTeamLeagueIdManagerSettingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdManagerSettings>>, TError,PutTeamLeagueIdManagerSettingsMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdManagerSettingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdManagerSettings>>, PutTeamLeagueIdManagerSettingsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdManagerSettings(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdManagerSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdManagerSettings>>>
    export type PutTeamLeagueIdManagerSettingsMutationBody = ManagerSettings | undefined
    export type PutTeamLeagueIdManagerSettingsMutationError = ErrorResult | ProblemDetails
    export type PutTeamLeagueIdManagerSettingsMutationVariables = {id: number;data?: ManagerSettings}

    export const usePutTeamLeagueIdManagerSettings = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdManagerSettings>>, TError,PutTeamLeagueIdManagerSettingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdManagerSettings>>,
        TError,
        PutTeamLeagueIdManagerSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdManagerSettingsMutationOptions(options), queryClient);
    }
    export const putTeamLeagueIdReassign = (
    id: number,
    int32RosterLevelKeyValuePair?: Int32RosterLevelKeyValuePair[],
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/Reassign`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: int32RosterLevelKeyValuePair, signal
    },
      );
    }




export const getPutTeamLeagueIdReassignMutationKey = () => ['putTeamLeagueIdReassign'] as const;

export const getPutTeamLeagueIdReassignMutationOptions = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdReassign>>, TError,PutTeamLeagueIdReassignMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdReassign>>, TError,PutTeamLeagueIdReassignMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdReassignMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdReassign>>, PutTeamLeagueIdReassignMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdReassign(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdReassignMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdReassign>>>
    export type PutTeamLeagueIdReassignMutationBody = Int32RosterLevelKeyValuePair[] | undefined
    export type PutTeamLeagueIdReassignMutationError = ErrorResult
    export type PutTeamLeagueIdReassignMutationVariables = {id: number;data?: Int32RosterLevelKeyValuePair[]}

    export const usePutTeamLeagueIdReassign = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdReassign>>, TError,PutTeamLeagueIdReassignMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdReassign>>,
        TError,
        PutTeamLeagueIdReassignMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdReassignMutationOptions(options), queryClient);
    }
    export const putTeamLeagueIdFreeAgentBid = (
    id: number,
    placeFreeAgentBidDto?: PlaceFreeAgentBidDto,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/FreeAgentBid`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: placeFreeAgentBidDto, signal
    },
      );
    }




export const getPutTeamLeagueIdFreeAgentBidMutationKey = () => ['putTeamLeagueIdFreeAgentBid'] as const;

export const getPutTeamLeagueIdFreeAgentBidMutationOptions = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdFreeAgentBid>>, TError,PutTeamLeagueIdFreeAgentBidMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdFreeAgentBid>>, TError,PutTeamLeagueIdFreeAgentBidMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdFreeAgentBidMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdFreeAgentBid>>, PutTeamLeagueIdFreeAgentBidMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdFreeAgentBid(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdFreeAgentBidMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdFreeAgentBid>>>
    export type PutTeamLeagueIdFreeAgentBidMutationBody = PlaceFreeAgentBidDto | undefined
    export type PutTeamLeagueIdFreeAgentBidMutationError = ErrorResult
    export type PutTeamLeagueIdFreeAgentBidMutationVariables = {id: number;data?: PlaceFreeAgentBidDto}

    export const usePutTeamLeagueIdFreeAgentBid = <TError = ErrorResult,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdFreeAgentBid>>, TError,PutTeamLeagueIdFreeAgentBidMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdFreeAgentBid>>,
        TError,
        PutTeamLeagueIdFreeAgentBidMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdFreeAgentBidMutationOptions(options), queryClient);
    }
    /**
 * @summary Renames a team (city, name, abbreviation). Owner-only.
 */
export const putTeamLeagueIdName = (
    id: number,
    teamNameUpdateRequest?: TeamNameUpdateRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/Name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: teamNameUpdateRequest, signal
    },
      );
    }




export const getPutTeamLeagueIdNameMutationKey = () => ['putTeamLeagueIdName'] as const;

export const getPutTeamLeagueIdNameMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdName>>, TError,PutTeamLeagueIdNameMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdName>>, TError,PutTeamLeagueIdNameMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdNameMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdName>>, PutTeamLeagueIdNameMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdName(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdNameMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdName>>>
    export type PutTeamLeagueIdNameMutationBody = TeamNameUpdateRequest | undefined
    export type PutTeamLeagueIdNameMutationError = ErrorResult | ProblemDetails
    export type PutTeamLeagueIdNameMutationVariables = {id: number;data?: TeamNameUpdateRequest}

    /**
 * @summary Renames a team (city, name, abbreviation). Owner-only.
 */
export const usePutTeamLeagueIdName = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdName>>, TError,PutTeamLeagueIdNameMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdName>>,
        TError,
        PutTeamLeagueIdNameMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdNameMutationOptions(options), queryClient);
    }
    /**
 * @summary Sets (or clears, via nulls) the team's display colors. Owner-only.
 */
export const putTeamLeagueIdColor = (
    id: number,
    teamColorUpdateRequest?: TeamColorUpdateRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/Color`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: teamColorUpdateRequest, signal
    },
      );
    }




export const getPutTeamLeagueIdColorMutationKey = () => ['putTeamLeagueIdColor'] as const;

export const getPutTeamLeagueIdColorMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdColor>>, TError,PutTeamLeagueIdColorMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdColor>>, TError,PutTeamLeagueIdColorMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdColorMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdColor>>, PutTeamLeagueIdColorMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putTeamLeagueIdColor(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdColorMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdColor>>>
    export type PutTeamLeagueIdColorMutationBody = TeamColorUpdateRequest | undefined
    export type PutTeamLeagueIdColorMutationError = ErrorResult | ProblemDetails
    export type PutTeamLeagueIdColorMutationVariables = {id: number;data?: TeamColorUpdateRequest}

    /**
 * @summary Sets (or clears, via nulls) the team's display colors. Owner-only.
 */
export const usePutTeamLeagueIdColor = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdColor>>, TError,PutTeamLeagueIdColorMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdColor>>,
        TError,
        PutTeamLeagueIdColorMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdColorMutationOptions(options), queryClient);
    }
    /**
 * @summary Releases (gives up ownership of) an owned team. Owner-only; enforces the 30-day minimum.
 */
export const postTeamLeagueIdRelease = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/Release`, method: 'POST', signal
    },
      );
    }




export const getPostTeamLeagueIdReleaseMutationKey = () => ['postTeamLeagueIdRelease'] as const;

export const getPostTeamLeagueIdReleaseMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTeamLeagueIdRelease>>, TError,PostTeamLeagueIdReleaseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTeamLeagueIdRelease>>, TError,PostTeamLeagueIdReleaseMutationVariables, TContext> => {

const mutationKey = getPostTeamLeagueIdReleaseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTeamLeagueIdRelease>>, PostTeamLeagueIdReleaseMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  postTeamLeagueIdRelease(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostTeamLeagueIdReleaseMutationResult = NonNullable<Awaited<ReturnType<typeof postTeamLeagueIdRelease>>>

    export type PostTeamLeagueIdReleaseMutationError = ErrorResult | ProblemDetails
    export type PostTeamLeagueIdReleaseMutationVariables = {id: number}

    /**
 * @summary Releases (gives up ownership of) an owned team. Owner-only; enforces the 30-day minimum.
 */
export const usePostTeamLeagueIdRelease = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTeamLeagueIdRelease>>, TError,PostTeamLeagueIdReleaseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTeamLeagueIdRelease>>,
        TError,
        PostTeamLeagueIdReleaseMutationVariables,
        TContext
      > => {
      return useMutation(getPostTeamLeagueIdReleaseMutationOptions(options), queryClient);
    }
    /**
 * @summary Gets the team's roster with pending position change info and projected ratings for each available target position.
 */
export const getTeamLeagueIdPendingPositionChanges = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<PendingPositionChangesRoster>(
      {url: `/Team/League/${id}/PendingPositionChanges`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdPendingPositionChangesQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/PendingPositionChanges`
    ] as const;
    }


export const getGetTeamLeagueIdPendingPositionChangesQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdPendingPositionChangesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>> = ({ signal }) => getTeamLeagueIdPendingPositionChanges(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdPendingPositionChangesQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>>
export type GetTeamLeagueIdPendingPositionChangesQueryError = ProblemDetails


export function useGetTeamLeagueIdPendingPositionChanges<TData = Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdPendingPositionChanges<TData = Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdPendingPositionChanges<TData = Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets the team's roster with pending position change info and projected ratings for each available target position.
 */

export function useGetTeamLeagueIdPendingPositionChanges<TData = Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdPendingPositionChanges>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdPendingPositionChangesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Sets or replaces a pending position change for a player. The change will be applied at the start of the next season.
 */
export const putTeamLeagueIdPendingPositionChangesPlayerId = (
    id: number,
    playerId: number,
    pendingPositionChangeRequest?: PendingPositionChangeRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/PendingPositionChanges/${playerId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pendingPositionChangeRequest, signal
    },
      );
    }




export const getPutTeamLeagueIdPendingPositionChangesPlayerIdMutationKey = () => ['putTeamLeagueIdPendingPositionChangesPlayerId'] as const;

export const getPutTeamLeagueIdPendingPositionChangesPlayerIdMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdPendingPositionChangesPlayerId>>, TError,PutTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdPendingPositionChangesPlayerId>>, TError,PutTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables, TContext> => {

const mutationKey = getPutTeamLeagueIdPendingPositionChangesPlayerIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeamLeagueIdPendingPositionChangesPlayerId>>, PutTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables> = (props) => {
          const {id,playerId,data} = props ?? {};

          return  putTeamLeagueIdPendingPositionChangesPlayerId(id,playerId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeamLeagueIdPendingPositionChangesPlayerIdMutationResult = NonNullable<Awaited<ReturnType<typeof putTeamLeagueIdPendingPositionChangesPlayerId>>>
    export type PutTeamLeagueIdPendingPositionChangesPlayerIdMutationBody = PendingPositionChangeRequest | undefined
    export type PutTeamLeagueIdPendingPositionChangesPlayerIdMutationError = ErrorResult | ProblemDetails
    export type PutTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables = {id: number;playerId: number;data?: PendingPositionChangeRequest}

    /**
 * @summary Sets or replaces a pending position change for a player. The change will be applied at the start of the next season.
 */
export const usePutTeamLeagueIdPendingPositionChangesPlayerId = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeamLeagueIdPendingPositionChangesPlayerId>>, TError,PutTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeamLeagueIdPendingPositionChangesPlayerId>>,
        TError,
        PutTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables,
        TContext
      > => {
      return useMutation(getPutTeamLeagueIdPendingPositionChangesPlayerIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancels a pending position change for a player.
 */
export const deleteTeamLeagueIdPendingPositionChangesPlayerId = (
    id: number,
    playerId: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Team/League/${id}/PendingPositionChanges/${playerId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationKey = () => ['deleteTeamLeagueIdPendingPositionChangesPlayerId'] as const;

export const getDeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamLeagueIdPendingPositionChangesPlayerId>>, TError,DeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamLeagueIdPendingPositionChangesPlayerId>>, TError,DeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables, TContext> => {

const mutationKey = getDeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamLeagueIdPendingPositionChangesPlayerId>>, DeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables> = (props) => {
          const {id,playerId} = props ?? {};

          return  deleteTeamLeagueIdPendingPositionChangesPlayerId(id,playerId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamLeagueIdPendingPositionChangesPlayerId>>>

    export type DeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationError = ErrorResult | ProblemDetails
    export type DeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables = {id: number;playerId: number}

    /**
 * @summary Cancels a pending position change for a player.
 */
export const useDeleteTeamLeagueIdPendingPositionChangesPlayerId = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamLeagueIdPendingPositionChangesPlayerId>>, TError,DeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamLeagueIdPendingPositionChangesPlayerId>>,
        TError,
        DeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTeamLeagueIdPendingPositionChangesPlayerIdMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns the defense-editor payload for the team. Requires auth; user-aware
API surface, but the underlying service returns null (404) for non-owners
AND for owners whose rosters are locked -- these pages are edit-only.
 */
export const getTeamLeagueIdDefense = (
    id: number,
    params: GetTeamLeagueIdDefenseParams,
 signal?: AbortSignal
) => {


      return fetcher<TeamDefenseViewResponse>(
      {url: `/Team/League/${id}/Defense`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTeamLeagueIdDefenseQueryKey = (id: number,
    params?: GetTeamLeagueIdDefenseParams,) => {
    return [
    `/Team/League/${id}/Defense`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamLeagueIdDefenseQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError = ProblemDetails>(id: number,
    params: GetTeamLeagueIdDefenseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdDefenseQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdDefense>>> = ({ signal }) => getTeamLeagueIdDefense(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdDefenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdDefense>>>
export type GetTeamLeagueIdDefenseQueryError = ProblemDetails


export function useGetTeamLeagueIdDefense<TData = Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError = ProblemDetails>(
 id: number,
    params: GetTeamLeagueIdDefenseParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdDefense>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdDefense>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdDefense<TData = Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError = ProblemDetails>(
 id: number,
    params: GetTeamLeagueIdDefenseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdDefense>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdDefense>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdDefense<TData = Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError = ProblemDetails>(
 id: number,
    params: GetTeamLeagueIdDefenseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the defense-editor payload for the team. Requires auth; user-aware
API surface, but the underlying service returns null (404) for non-owners
AND for owners whose rosters are locked -- these pages are edit-only.
 */

export function useGetTeamLeagueIdDefense<TData = Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError = ProblemDetails>(
 id: number,
    params: GetTeamLeagueIdDefenseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdDefense>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdDefenseQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the batting-order-editor payload for the team. Same auth model
as Defense (404 for non-owner / locked rosters). LineupComplete=false
means the React page renders a placeholder; the actual editor only
renders when the lineup is full.
 */
export const getTeamLeagueIdBattingOrder = (
    id: number,
    params: GetTeamLeagueIdBattingOrderParams,
 signal?: AbortSignal
) => {


      return fetcher<TeamBattingOrderViewResponse>(
      {url: `/Team/League/${id}/BattingOrder`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTeamLeagueIdBattingOrderQueryKey = (id: number,
    params?: GetTeamLeagueIdBattingOrderParams,) => {
    return [
    `/Team/League/${id}/BattingOrder`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamLeagueIdBattingOrderQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError = ProblemDetails>(id: number,
    params: GetTeamLeagueIdBattingOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdBattingOrderQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>> = ({ signal }) => getTeamLeagueIdBattingOrder(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdBattingOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>>
export type GetTeamLeagueIdBattingOrderQueryError = ProblemDetails


export function useGetTeamLeagueIdBattingOrder<TData = Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError = ProblemDetails>(
 id: number,
    params: GetTeamLeagueIdBattingOrderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdBattingOrder<TData = Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError = ProblemDetails>(
 id: number,
    params: GetTeamLeagueIdBattingOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdBattingOrder<TData = Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError = ProblemDetails>(
 id: number,
    params: GetTeamLeagueIdBattingOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the batting-order-editor payload for the team. Same auth model
as Defense (404 for non-owner / locked rosters). LineupComplete=false
means the React page renders a placeholder; the actual editor only
renders when the lineup is full.
 */

export function useGetTeamLeagueIdBattingOrder<TData = Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError = ProblemDetails>(
 id: number,
    params: GetTeamLeagueIdBattingOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdBattingOrder>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdBattingOrderQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns up to `count` upcoming games for the team. Requires auth.
Standalone widget endpoint -- used by the React UpcomingGamesWidget
component on the lineup editors (and pitchingroles in 5c).
 */
export const getTeamLeagueIdUpcomingGames = (
    id: number,
    params?: GetTeamLeagueIdUpcomingGamesParams,
 signal?: AbortSignal
) => {


      return fetcher<TeamUpcomingGamesResponse>(
      {url: `/Team/League/${id}/UpcomingGames`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetTeamLeagueIdUpcomingGamesQueryKey = (id: number,
    params?: GetTeamLeagueIdUpcomingGamesParams,) => {
    return [
    `/Team/League/${id}/UpcomingGames`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamLeagueIdUpcomingGamesQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError = ProblemDetails>(id: number,
    params?: GetTeamLeagueIdUpcomingGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdUpcomingGamesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>> = ({ signal }) => getTeamLeagueIdUpcomingGames(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdUpcomingGamesQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>>
export type GetTeamLeagueIdUpcomingGamesQueryError = ProblemDetails


export function useGetTeamLeagueIdUpcomingGames<TData = Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetTeamLeagueIdUpcomingGamesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdUpcomingGames<TData = Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdUpcomingGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdUpcomingGames<TData = Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdUpcomingGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns up to `count` upcoming games for the team. Requires auth.
Standalone widget endpoint -- used by the React UpcomingGamesWidget
component on the lineup editors (and pitchingroles in 5c).
 */

export function useGetTeamLeagueIdUpcomingGames<TData = Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError = ProblemDetails>(
 id: number,
    params?: GetTeamLeagueIdUpcomingGamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdUpcomingGames>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdUpcomingGamesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the team home-page payload (overview, financials,
stadium, playoff history, recent + upcoming games). Requires auth;
user-aware (canRecruit and canManage flags resolved server-side
from the calling user's identity). 404 when the team or its
league is missing.
 */
export const getTeamLeagueIdView = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<TeamViewResponse>(
      {url: `/Team/League/${id}/View`, method: 'GET', signal
    },
      );
    }




export const getGetTeamLeagueIdViewQueryKey = (id: number,) => {
    return [
    `/Team/League/${id}/View`
    ] as const;
    }


export const getGetTeamLeagueIdViewQueryOptions = <TData = Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamLeagueIdViewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamLeagueIdView>>> = ({ signal }) => getTeamLeagueIdView(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamLeagueIdViewQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamLeagueIdView>>>
export type GetTeamLeagueIdViewQueryError = ProblemDetails


export function useGetTeamLeagueIdView<TData = Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdView>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdView<TData = Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamLeagueIdView>>,
          TError,
          Awaited<ReturnType<typeof getTeamLeagueIdView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamLeagueIdView<TData = Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the team home-page payload (overview, financials,
stadium, playoff history, recent + upcoming games). Requires auth;
user-aware (canRecruit and canManage flags resolved server-side
from the calling user's identity). 404 when the team or its
league is missing.
 */

export function useGetTeamLeagueIdView<TData = Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamLeagueIdView>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamLeagueIdViewQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






